<template>
  <v-row :key="week.weekNumber" class="calendar-week-wrapper" no-gutters>
    <v-col :style="{maxWidth: $vuetify.breakpoint.smAndDown ? '20px' : '18px'}"
           class="mr-1" style="z-index: 2;">
      <div :class="week.weekNumber % 2 === 0 ? 'even' : 'odd'"
           class="calendar-week d-flex flex-column justify-start align-center fill-height">
        <div class="calendar-week-number text-center">{{ week.weekNumber }}</div>
      </div>
    </v-col>
    <v-col>
      <template v-if="week.productionExceptions.length > 0">
        <v-alert class="py-2 py-md-3 mx-2 mt-2 mb-2" color="info" text>
          <div class="font-weight-bold text-body-2 text-uppercase text-md-subtitle-2 mb-1">
            {{ $t('production_timeline.exceptions_for_week') }} {{ week.weekNumber }}:
          </div>
          <div v-for="exception in week.productionExceptions" :key="exception.id"
               class="text-caption text-md-body-2">
            {{ $t('production_timeline.production_exception_types.' + exception.type) }}
            {{ $formatWeekDayLong(exception.date) }} {{ exception.duration }} tuntia -
            {{ exception.description }}
          </div>
        </v-alert>
      </template>
      <component :is="isAdmin ? 'draggable' : 'div'"
                 :list="week.projects"
                 class="list-group"
                 :style="week.projects.length === 0 && !lineHasProjects ? { minHeight: '200px' } : {}"
                 group="projects"
                 handle=".handle"
                 @change="(e) => $emit('drag-change', e)">
        <template v-for="(projectLog) in week.projects">
          <project-card
            :key="projectLog.id"
            :project-log="projectLog"
            :updating="updating"
            :production-lines="productionLines"
            class="list-group-item"
            @assign-to-line="(e) => $emit('assign-to-line', e)"
            @unschedule="(e) => $emit('unschedule', e)"/>
        </template>
      </component>
    </v-col>
  </v-row>
</template>

<script>
import Draggable from 'vuedraggable';
import ProjectCard from './ProjectCard';

export default {
  name: 'ProductionLineWeek',
  components: { Draggable, ProjectCard },
  props: {
    week: {
      type: Object,
      required: true
    },
    isAdmin: {
      type: Boolean,
      default: false
    },
    updating: {
      type: Boolean,
      default: false
    },
    lineHasProjects: {
      type: Boolean,
      default: false
    },
    productionLines: {
      type: Array,
      default: () => []
    }
  }
};
</script>
